import React from 'react'

const Image: React.FC<React.ImgHTMLAttributes<HTMLImageElement>> = (props) => {
  return (
    <img
      {...props}
      width={props.width ? props.width : '100%'}
      style={{
        borderRadius: 10,
      }}
    />
  )
}

export default Image
